import { useEffect, useState } from 'react';
import * as Location from 'expo-location';
import { LocationObject } from 'expo-location/src/Location.types';
import { useAlert } from '@rahtab/ui';

export const useLocation = () => {
  const [location, setLocation] = useState<LocationObject | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [permissionStatus, setPermissionStatus] = useState<Location.PermissionStatus>();
  const alert = useAlert();
  const getPermission = async () => {
    let { status } = await Location.requestPermissionsAsync();
    setPermissionStatus(status);
  };

  useEffect(() => {
    (async () => {
      try {
        let { status } = await Location.requestPermissionsAsync();
        setPermissionStatus(status);
        if (status !== 'granted') {
          setError('دسترسی به موقعیت جغرافیایی برای برنامه فراهم نیست.');
          alert({
            message: 'دسترسی به موقعیت جغرافیایی برای برنامه فراهم نیست.',
          });
          return;
        }
        let geoLocation = await Location.getCurrentPositionAsync({});
        setLocation(geoLocation);
      } catch (err) {
        console.log('error in getting loc or access', err);
      }
    })();
  }, []);
  return { location, error, getPermission, permissionStatus };
};
